// Серый дилер не выбирает ДЦ и город вручную: ДЦ берётся его собственный (autoSellerDc), город — из карточки ДЦ.
// Выбранное в форме вручную (селект показан, если автовыбор не сработал) важнее подставленного.
export const carDcPayload = (values, autoDc) => {
  const picked = [].concat(values?.dc || []).map((dc) => dc?.value);
  const dcIds = (autoDc ? [autoDc.value] : picked).filter((value) => value != null);
  return { dcIds, cityId: values?.cityId?.value ?? autoDc?.cityId ?? undefined };
};
